import { render } from "./ForgotPassword.vue?vue&type=template&id=32a9babe&scoped=true&ts=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"

import "./ForgotPassword.vue?vue&type=style&index=0&id=32a9babe&lang=scss&scoped=true"
import "./ForgotPassword.vue?vue&type=style&index=1&id=32a9babe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a9babe"]])

export default __exports__